import { get } from "lodash";
import { states } from "../../../reducers/queriesStates";
import { HubConnectionState } from "@microsoft/signalr";

const CONNECTION_TIMER = 60000;
let handleConnectLastState;
let handleStartConnection;
let handleAddUserToGroup;
export const unitFilterService = {
  clearTimeoutConnection: function () {
    clearTimeout(handleConnectLastState);
    clearTimeout(handleStartConnection);
    clearTimeout(handleAddUserToGroup);
  },
  didMount: function (props) {
    const {
      dataConnectionStateSR,
      connectionSR,
      dataStateUnits,
      onConnectLastState,
      onGetWinterAreasSimple,
      onStartConnection,
      filterCarsListItems,
      dataStartConnectionStateSR,
      onGetCars,
    } = props;

    if (dataStateUnits === states.NOT_REQUESTED) {
      onGetCars(filterCarsListItems);
    }

    //connect if never connection
    if (dataConnectionStateSR !== states.READY && dataStateUnits === states.READY) {
      onConnectLastState();
    }

    //start connection if app has connected yet
    if (
      dataStartConnectionStateSR === states.NOT_REQUESTED &&
      dataConnectionStateSR === states.READY &&
      dataStateUnits === states.READY &&
      !!connectionSR &&
      connectionSR.connectionState === HubConnectionState.Disconnected
    ) {
      onStartConnection(connectionSR);
    }
  },
  didUpdate: function (prevProps, props) {
    const {
      onGetCars,
      handleScrollTo,
      dataStateDeleteCarBookmark,
      dataStateSetCarBookmark,
      filterCarsListItems,
      dataStateFilterCars,
      clearDataStateFilterCars,
      dataStateUnits,
      listUnits,
      dataConnectionStateSR,
      connectionSR,
      dataStartConnectionStateSR,
      dataUserGroupStateSR,
      dataRecieveUnitsLastStateSR,
      onStartConnection,
      onAddUserToGroup,
      onHandleRecieveUnitsLastState,
      onConnectLastState,
    } = props;

    if (get(prevProps, ["dataStateUnits"]) !== states.READY && dataStateUnits === states.READY) {
      const prevUnitsList = get(prevProps, ["listUnits"], []);

      if (listUnits.length > 0 && prevUnitsList.length > 0) handleScrollTo(0);
    }

    if (filterCarsListItems !== undefined) {
      if (get(prevProps, ["dataStateFilterCars"]) !== states.READY && dataStateFilterCars === states.READY) {
        onGetCars(filterCarsListItems);
      }

      if (get(prevProps, ["clearDataStateFilterCars"]) !== states.READY && clearDataStateFilterCars === states.READY) {
        onGetCars(filterCarsListItems);
      }

      if (get(prevProps, ["dataStateSetCarBookmark"]) !== states.READY && dataStateSetCarBookmark === states.READY) {
        onGetCars(filterCarsListItems);
      }

      if (get(prevProps, ["dataStateDeleteCarBookmark"]) !== states.READY && dataStateDeleteCarBookmark === states.READY) {
        onGetCars(filterCarsListItems);
      }
    }

    //connect if never connection
    if (dataConnectionStateSR === states.NOT_REQUESTED && dataStateUnits === states.READY) {
      onConnectLastState();
    }

    // repeat connection if previous was a failure or closed
    if (dataConnectionStateSR === states.FAILURE && prevProps.dataConnectionStateSR !== states.FAILURE) {
      handleConnectLastState = setTimeout(() => {
        onConnectLastState();
      }, CONNECTION_TIMER);
    }

    // connect if previous connection was stopped
    if (
      dataStartConnectionStateSR === states.NOT_REQUESTED &&
      prevProps.dataStartConnectionStateSR !== states.NOT_REQUESTED &&
      dataConnectionStateSR === states.READY &&
      connectionSR.connectionState === HubConnectionState.Disconnected
    ) {
      onStartConnection(connectionSR);
    }

    // reconnect if connection is ready, but previous attempt to start was a failure
    if (
      dataStartConnectionStateSR === states.FAILURE &&
      prevProps.dataStartConnectionStateSR !== states.FAILURE &&
      dataConnectionStateSR === states.READY
    ) {
      handleStartConnection = setTimeout(() => {
        onStartConnection(connectionSR);
      }, CONNECTION_TIMER);
    }

    // connection is started, then add usergroup
    if (dataStartConnectionStateSR === states.READY && prevProps.dataStartConnectionStateSR !== states.READY) {
      onAddUserToGroup(connectionSR);
    }

    // repeat adding user to group if previous attempt was a failure
    if (dataUserGroupStateSR === states.FAILURE && prevProps.dataUserGroupStateSR !== states.FAILURE) {
      handleAddUserToGroup = setTimeout(() => {
        onAddUserToGroup(connectionSR);
      }, CONNECTION_TIMER);
    }

    // trigger to start recieve lastState
    if (
      dataConnectionStateSR === states.READY &&
      dataStartConnectionStateSR === states.READY &&
      dataUserGroupStateSR === states.READY &&
      dataRecieveUnitsLastStateSR === states.NOT_REQUESTED
    ) {
      onHandleRecieveUnitsLastState(connectionSR);
    }
  },
};
